// src/components/PrivateRoutes/PrivateSupportRoute.jsx
import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

const PrivateSupportRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkSupport = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.get("/api/has-support-access", {
          headers: { Authorization: `Bearer ${token}` },
        });

        setHasAccess(!!response.data.hasAccess);
      } catch (err) {
        console.error("Error checking support access", err);
      } finally {
        setIsLoading(false);
      }
    };

    checkSupport();
  }, []);

  if (isLoading) return <LoadingSpinner />;

  if (!hasAccess) return <Navigate to="/" />;

  return children;
};

export default PrivateSupportRoute;
